// extracted by mini-css-extract-plugin
export default {"SideBarLayout":"SideBar_SideBarLayout__7wD9q"};